import { StyleSheet } from 'aphrodite';
import { brandPrimary, header, nameCircles } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	modal: {
		...CssSelectors.allDescendants(
			{
				maxWidth: '100vw',
			},
			'.modal-overlay-content'
		),
	},
	container: {
		padding: 16,
	},
	importTabbarItem: {
		fontSize: 12,
	},
	importTabbar: {
		height: 35,
	},
	importTabbarContent: {
		paddingTop: 15,
		width: '100%',
	},
	modalContainer: {
		minHeight: 500,
		minWidth: 450,
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-around',
	},
	uploadContainer: {
		minHeight: 400,
		minWidth: 400,
		background: nameCircles,
	},
	importContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		gap: 20,
	},
	header: {
		margin: 0,
		color: brandPrimary,
	},
	csvImportMapping: {
		height: 'calc(100vh - 100px)',
		width: 'calc(100vw - 100px)',
	},
	pickFileOptions: {
		textAlign: 'left',
		width: '100%',
	},
	tagOptionsBlock: {
		marginBottom: 16,
	},
	optionsTitle: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 8,
	},
	optionsSubtitle: {
		fontSize: 14,
		marginBottom: 8,
	},
	tagSearchField: {
		marginBottom: 8,
		width: '100%',
	},
	dataRefreshRow: {
		marginBottom: 8,
	},
	uploadDropInner: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		minHeight: 280,
		padding: 16,
		textAlign: 'center',
	},
	uploadBrowseMessage: {
		color: header,
		fontSize: 16,
		marginTop: 12,
	},
	hiddenFileInput: {
		height: 0,
		opacity: 0,
		pointerEvents: 'none',
		position: 'fixed',
		visibility: 'hidden',
		width: 0,
		zIndex: -1,
	},
});
